// extracted by mini-css-extract-plugin
export var body = "_o0-8";
export var button = "_o0-0";
export var closeButton = "_o0-5";
export var content = "_o0-3";
export var empty = "_o0-f";
export var grid = "_o0-c";
export var header = "_o0-4";
export var icon = "_o0-1";
export var option = "_o0-d";
export var optionSelected = "_o0-e";
export var overlay = "_o0-2";
export var searchIcon = "_o0-a";
export var searchInput = "_o0-b";
export var searchWrapper = "_o0-9";
export var title = "_o0-6";
export var visuallyHidden = "_o0-7";